<template>
    <div class="configurator-container">
        <div class="configurator">
            <v-row>
                <v-col></v-col>
                <div class="template-selection" right>
                    <v-subheader class="pa-0">Select Template:</v-subheader>
                    <div>
                        <v-select color="#42b983" :items="availableTemplates" item-text="displayName" item-value="name"
                            v-model="currentlySelectedTemplate">
                        </v-select>
                    </div>
                    <MessageWrapper :messageWrapper="projectConfiguration.template.messages" />
                </div>
            </v-row>
            <v-row>
                <v-text-field autofocus solo label="Project Name:" id="projectName" hide-details
                    v-model="projectConfiguration.name.value" />
                <v-btn v-on:click="initializeProject" class="send-btn" color="#42b983" dark large>
                    Submit Configuration
                    <v-icon right>mdi-cube-send</v-icon>
                </v-btn>
            </v-row>
            <MessageWrapper :messageWrapper="projectConfiguration.name.messages" />
            <v-row class="feature-configurations">
                <v-col cols="4">
                    <div v-if="currentlySelectedTemplate == 'MICROSERVICE'">
                        <v-subheader class="pa-0">Port Configuration</v-subheader>
                        <v-row class="feature-configuration">
                            <v-slider v-model="projectConfiguration.port.value" class="applicationPortSlider mx-0 px-0"
                                :min="portRange.min" :max="portRange.max" hide-details :thumb-label="true" thumb-size="48"
                                track-color="secondary">
                                <template v-slot:append>
                                    <v-text-field v-model="projectConfiguration.port.value" class="ma-0 pa-0" hide-details
                                        single-line type="number" style="width: 60px"></v-text-field>
                                </template>
                            </v-slider>
                        </v-row>
                        <MessageWrapper :messageWrapper="projectConfiguration.port.messages" />
                    </div>

                    <div v-if="currentlySelectedTemplate == 'UTIL'">
                        <v-subheader class="pa-0">
                            Generate Standalone Util
                        </v-subheader>
                        <div class="feature-configuration">
                            <v-switch class="reviewer" v-model="generateStandalone" label="Yes/No"
                                :value="generateStandalone"></v-switch>
                        </div>
                    </div>
                </v-col>
                <v-col cols="4">
                    <div v-if="currentlySelectedTemplate == 'MICROSERVICE'">
                        <v-subheader class="pa-0">Host Configuration</v-subheader>
                        <div class="feature-configuration">
                            <v-select color="#42b983" :items="availableHosts" item-text="displayName" item-value="name"
                                v-model="currentlySelectedHost">
                            </v-select>
                        </div>
                        <MessageWrapper :messageWrapper="projectConfiguration.host.messages" />
                    </div>
                    

                    <div v-if="currentlySelectedTemplate == 'UTIL'">
                        <v-subheader class="pa-0">
                            Generate Starter
                        </v-subheader>
                        <div class="feature-configuration">
                            <v-switch class="reviewer" v-model="generateStarter" label="Yes/No"
                                :value="generateStarter"></v-switch>
                        </div>
                    </div>
                </v-col>
                <v-col cols="4">
                    <v-subheader class="pa-0">Reviewer Configuration</v-subheader>
                    <div class="feature-configuration" v-for="reviewer in availableReviewers" :key="reviewer.uuid">
                        <v-switch class="reviewer" v-model="selectedReviewers" :label="reviewer.displayName"
                            :value="reviewer"></v-switch>
                    </div>
                    <MessageWrapper :messageWrapper="projectConfiguration.host.messages" />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import InitializerConfigurationService from "../../services/ConfigurationOptionsService";
import MessageWrapper from "./MessageWrapper";

export default {
    name: 'ConfigurationDefinition',
    components: {
        MessageWrapper: MessageWrapper
    },
    data: () => {
        return {
            portRange: {},
            availableHosts: [],
            currentlySelectedHost: "",
            host: {},
            availableTemplates: [],
            currentlySelectedTemplate: "",
            template: {},
            availableReviewers: [],
            selectedReviewers: [],
            generateStarter: false,
            generateStandalone: false
        }
    },
    props: [
        'projectConfiguration'
    ],
    methods: {
        initializeProject: function () {
            let host = this.availableHosts.filter(current => {
                return current.name === this.currentlySelectedHost;
            })[0];

            let template = this.availableTemplates.filter(current => {
                return current.name === this.currentlySelectedTemplate;
            })[0];

            this.projectConfiguration.host.value = host.name;
            this.projectConfiguration.template.value = template.name;
            this.projectConfiguration.reviewers.value = this.selectedReviewers;
            this.projectConfiguration.generateStarter = this.generateStarter;
            this.projectConfiguration.generateStandalone = this.generateStandalone;

            console.log(this.projectConfiguration.generateStandalone);
            this.$emit('submitConfiguration');
        }
    },
    created() {
        InitializerConfigurationService
            .retrieveAvailableHosts()
            .then(availableHosts => {
                this.availableHosts = availableHosts;
                this.currentlySelectedHost = this.availableHosts[0].name;
            });
        InitializerConfigurationService
            .retrieveAvailableTemplates()
            .then(availableTemplates => {
                this.availableTemplates = availableTemplates;
                this.currentlySelectedTemplate = this.availableTemplates[0].name;
            });
        InitializerConfigurationService
            .retrievePortRange()
            .then(portRange => {
                this.portRange = {
                    min: portRange.min,
                    max: portRange.max
                };
                this.projectConfiguration.port.value = portRange.nextFreePort;
            });
        InitializerConfigurationService
            .retrieveAvailableReviewers()
            .then(availableReviewers => {
                this.availableReviewers = availableReviewers;
                this.selectedReviewers = availableReviewers;
            });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.configurator {
    padding: 0 10%;
    margin-top: 50px;
}

.v-card.v-select-list {
    text-align: left;
}

.configurator .v-slider {
    height: 42px;
    margin-right: 24px;
}

.configurator .send-btn {
    margin-left: 50px;
    height: 48px;
}

.feature-configurations {
    margin-top: 25px;
}

.feature-configuration {
    margin: 0 100px 0 25px;
}

.feature-configuration>div {
    padding-top: 12px;
}

.feature-configuration .reviewer {
    margin-top: 0;
}

.feature-configuration .reviewer .v-messages {
    display: none;
}

.template-selection {
    width: 255.35px;
}

.template-selection .v-subheader {
    flex-direction: row-reverse;
    height: auto;
    display: block;
    text-align: end;
}

.template-selection .v-select__selections {
    flex-direction: row-reverse;
}

.v-menu__content {
    max-height: 550px !important;
}
</style>
